export default __webpack_public_path__ + "static/media/desktop-logo.1ac64b3f.svg";